<div class="page-header">
  <div class="page-header-text" data-testid="landingPageHeaderText">Let’s confirm why you’re here</div>
</div>

<div class="page-body">

  <form [formGroup]="pendingPolicyForm" id="pendingPolicyForm" novalidate>
    <fieldset class="bolt-fieldset bolt--radios" [ngClass]="{'bolt-invalid':pendingPolicyForm.get('option')?.touched && pendingPolicyForm.get('option')?.errors?.['required']}">
      <legend>
        <span class="bolt-fieldset__name">
          I am here because:
        </span>
        <div class="bolt-fieldset__errors" *ngIf="pendingPolicyForm.get('option')?.touched && pendingPolicyForm.get('option')?.errors?.['required']">
          <bolt-field-error>
            Please select an option below.
          </bolt-field-error>
        </div>
      </legend>
      <div class="bolt-fieldset__body">
        <bolt-radio-control>
          <input id="option_1" name="option" type="radio" value="1" formControlName="option" ngDefaultControl />
          <label for="option_1">
            <bolt-radio-facade></bolt-radio-facade>
            <div class="bolt-field__label">
              I am applying for life insurance and want to make the initial premium <br />payment for my pending policy.
            </div>
          </label>
        </bolt-radio-control>
        <bolt-radio-control>
          <input id="option_2" name="option" type="radio" value="2" data-testid="payMyBillRadio" formControlName="option" ngDefaultControl />
          <label for="option_2">
            <bolt-radio-facade></bolt-radio-facade>
            <div class="bolt-field__label">
              I just want to pay my bill.
            </div>
          </label>
        </bolt-radio-control>
      </div>
    </fieldset>

  </form>
</div>

<div class="page-footer">
  <bolt-button-bar class="footer-button-bar">
    <bolt-button slot="cancel" (click)="onCancel()">Cancel</bolt-button>
    <bolt-button slot="forward" type="primary" data-testid="landingContinueButton" (click)="onSubmit()">Continue</bolt-button>
  </bolt-button-bar>
</div>